<template>
  <NSTMFatigueTable
    :id="`NSTMFatigueTable_SuperStructure_` + strUnitKey"
    ref="nstmTable"
    :moduleType="moduleType"
    @nstmFatigueChanged="(data) => fatigueUpdate(data)"
    disableFields
    spanBySpanFatigueTable
    :unitKey="strUnitKey"
  />
</template>
<script setup>
import { toRefs } from "vue";
import NSTMFatigueTable from "@/components/shared/NSTMFatigueTable.vue";
import { storeToRefs } from "pinia";
import { useSuperstructureStore } from "@/components/inspection/store/superStructure";

const props = defineProps({
  strUnitKey: Number,
  moduleType: String,
});
const { strUnitKey, moduleType } = toRefs(props);
const store = useSuperstructureStore();
const { superStructureData, isDirty } = storeToRefs(store);

const fatigueUpdate = (data) => {
  superStructureData.value.inspectionFCs = data.inspectionFCs;
  isDirty.value = true;
};
</script>
